export const APP_HOSTNAME = 'app.commetriq.de';

const MARKETING_HOSTNAMES = new Set(['commetriq.de', 'www.commetriq.de']);

const normalizePathname = (pathname = '/') => String(pathname || '/').replace(/\/+$/, '') || '/';

export const isMarketingHostname = (hostname = '') => MARKETING_HOSTNAMES.has(String(hostname).toLowerCase());

export const isAppDemoLocation = (locationLike) => {
    if (!locationLike) return false;
    return String(locationLike.hostname || '').toLowerCase() === APP_HOSTNAME
        && normalizePathname(locationLike.pathname) === '/demo';
};

export const getAppDemoUrl = () => `https://${APP_HOSTNAME}/demo`;
